import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SiteService } from 'src/app/_services/site.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { ErrorUtil } from "src/app/_utilities/error";

@Component({
  selector: "app-auto-assign-month",
  standalone: false,
  templateUrl: "./auto-assign-month.component.html",
  styleUrl: "./auto-assign-month.component.scss",
  providers: [DatePipe],
})
export class AutoAssignMonthComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  selectedMonth: any = new Date();
  monthTouched: boolean = false;
  data: any;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
    private siteServc: SiteService,
    private util: UtilServiceService, private errorUtil: ErrorUtil,
    private datePipe: DatePipe, private modalServc: BsModalService
  ) {
    super();
  }
  ngOnInit(): void {
    this.getLanguageData();
  }

  onMonthChange(value: any) {
    this.selectedMonth = value;
    if (!value) {
      this.monthTouched = true;
    }
  }

  onMonthBlur() {
    this.monthTouched = true;
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  onAutoAssignClick() {
    const monthDate: Date = new Date(this.selectedMonth);
    const startDate = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
    const endDate = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0, 23, 59, 59);

    let payload: any = {
      customerId: this.data.customer.id,
      contractId: this.data.contract.id,
      startDateTime: this.util.formatDateToISOString(startDate),
      endDateTime: this.util.formatDateToISOString(endDate)
    };

    this.siteServc.autoAssignMonth(payload).subscribe({
      next: (res: any) =>{
        if (res.status == 200){
          this.errorUtil.setErrorMessage(
            200,
            res.body.message,
            //this.translate?.general.status.unassigned.singular +' '+ this.translate?.jobOrder.label.plural + ' '+ this.translate?.setup.modules.procedure.messages.for + ' ' + this.datePipe.transform(this.selectedMonth, 'MMM yyyy')+" have been assigned successfully.",
            null,
            "success",
            2000,
          );
          this.modalServc.setDismissReason("auto_assign_success");
          this.modalRef.hide();
        }
      },
      error: (err: any) =>{
        console.log(err, 'err from auto assign month api printing..')
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000,
        );
      }
    })
  }
}
